import { useState } from "react";
import { useDispatch } from "react-redux";
import { readTWGPlansRequest } from "../../../store/Plan/planActions";

const SermonPlansHooks = () => {
  return { value: "", onChangeSearchBar: () => {} };
};

export default SermonPlansHooks;

export const AllSermonPlansHooks = () => {
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const [reloadData, setReloadData] = useState(false);

  const onChangeSearchBar = (e) => {
    setValue(e.target.value);
  };

  const fetchAllSermonPlans = (page, limit, searchCriteria, callback) => {
    dispatch(
      readTWGPlansRequest(
        { page, limit, typeonplan: 2, ...searchCriteria },
        (res) => {
          if (res.type === 1) {
            // Map the API response to the table headers
            const mappedData = (res.data || []).map((item) => {
              // Handle potentially empty object for dates
              const rawDate = item.createdDate;
              let formattedDate = "";

              if (rawDate && typeof rawDate === 'object' && Object.keys(rawDate).length === 0) {
                formattedDate = ""; // It's an empty object {}
              } else if (rawDate) {
                formattedDate = rawDate;
              }

              return {
                ...item,
                sermonPlan_title: item.planName || "Untitled",
                sermonPlan_description: item.youtubeLink || item.description || "",
                lastUpdatedDate: formattedDate,
                status: item.status || "COMPLETED", // /plans/twg items are usually completed
              };
            });

            callback({
              data: mappedData,
              totalRecords: res.total || mappedData.length,
            });
          } else {
            callback({ data: [], totalRecords: 0 });
          }
        }
      )
    );
  };

  const handleDelete = (row) => {
      };

  return {
    value,
    onChangeSearchBar,
    handleDelete,
    fetchAllSermonPlans,
    reloadData,
    setReloadData,
  };
};

export const AddSermonPlansHooks = (setLoading, data) => {
  const [activeTab, setActiveTab] = useState("en");
  const [sermonPlanInputs, setSermonPlanInputs] = useState({});
  const [sermonPlanUrlsInputs, setSermonPlanUrlsInputs] = useState({});
  const [UdownloadrlsInputs, setDownloadUrlsInputs] = useState({});
  const [tumbNailUrlsInputs, setTumbNailUrlsInputs] = useState({});
  const [commonSermonPlanUrlsInputs, setCommonUrlsInputs] = useState({});
  const [previewUrlsInputs, setPreviewUrlsInputs] = useState({});
  const [layoutArray, setLayoutArray] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [languagemeta, setLanguagemeta] = useState([]);

  return {
    activeTab,
    activeLanguageDetails: { language_code: "en", language_name: "English" },
    setActiveLanguageDetails: () => {},
    setActiveTab,
    handleInputChange: () => {},
    handleFileInputChange: () => {},
    handleSave: () => {},
    readLanguageData: [],
    sermonPlanInputs,
    setSermonPlanInputs,
    sermonPlanErrors: {},
    sermonPlanUrlsInputs,
    showSermonPlanLibraryModal: false,
    setShowSermonPlanLibraryModal: () => {},
    setSermonPlanUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange: () => {},
    selectedOptions,
    setSelectedOptions,
    deleteRelatedSermonPlan: () => {},
    setSelectedRelatedSermonPlanIndex: () => {},
    handleDropdownChange: () => {},
    setLayoutValues: () => {},
    handleSermonPlanLayoutChange: () => {},
    layoutValues: {},
    initialLayoutValues: {},
    setLayoutInfo: () => {},
    layoutInfo: false,
    handleDateChange: () => {},
    handleAddLayoutToArray: () => {},
    layoutArray,
    setAddedLayout: () => {},
    addedLayout: false,
    handleSermonPlanDateChange: () => {},
    options: [],
    handleDeleteLayoutFromArray: () => {},
    setIsLayoutEdit: () => {},
    isLayoutEdit: false,
    setEditLayoutIndex: () => {},
    setEditTargetLayout: () => {},
    editTargetLayout: "",
    handleLayoutUpdate: () => {},
    updateStateWithTranslation: () => {},
    handleCommonTumbNailInputChange: () => {},
    setCommonUrlsInputs,
    commonSermonPlanUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave: () => {},
    handleSaveLanguage: () => {},
    handleLibrarySermonPlanSelection: () => {},
    handleSendNotification: () => {},
    setLanguagemeta
  };
};
